module.exports = __webpack_public_path__ + "static/media/noi.9c67303c.png";